"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QrCodePdfButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ReactPDF = __importStar(require("@react-pdf/renderer"));
const react_1 = require("react");
var usePDF = ReactPDF.usePDF;
const react_ui_1 = require("@pasport/react-ui");
const QrCodeDocument_1 = require("./QrCodeDocument");
const QrCodePdfButton = ({ qrCodes, downloadFileName, children }) => {
    const [isLoaded, setIsLoaded] = (0, react_1.useState)(false);
    const [counter, setCounter] = (0, react_1.useState)(0);
    const pdfDocument = (0, react_1.useMemo)(() => {
        return (0, jsx_runtime_1.jsx)(QrCodeDocument_1.QrCodeDocument, { qrCodes: qrCodes, onLoadChange: (isLoaded) => {
                setIsLoaded(isLoaded);
                setCounter(counter + 1);
            } });
    }, [setIsLoaded, qrCodes]);
    const [instance, updateInstance] = usePDF({ document: pdfDocument });
    const [requestDownload, setRequestDownload] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (requestDownload && !instance.loading && isLoaded && instance.blob?.size && instance.blob?.size > 780) {
            (() => downloadPdf())();
        }
    }, [instance.loading, instance.blob, requestDownload, isLoaded]);
    const downloadPdf = async () => {
        const link = document.createElement('a');
        link.target = "_blank";
        link.href = instance.url ? instance.url : "";
        link.setAttribute('download', downloadFileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode?.removeChild(link);
        setRequestDownload(false);
    };
    const handleClick = () => {
        setRequestDownload(true);
    };
    return (0, jsx_runtime_1.jsx)(react_ui_1.Button, { color: "dark", onPress: handleClick, icon: requestDownload ? ((0, jsx_runtime_1.jsx)("div", { className: "spinner-border spinner-border-sm", role: "status", children: (0, jsx_runtime_1.jsx)("span", { className: "visually-hidden", children: "Loading..." }) })) : (0, jsx_runtime_1.jsx)(react_ui_1.DownloadIcon, {}), children: children });
};
exports.QrCodePdfButton = QrCodePdfButton;
